"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const uicon_arrow_simple_left_style_1 = __importDefault(require("./uicon.arrow.simple.left.style"));
class UiconArrowSimpleLeft extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.render = () => {
            const { classes, size } = this.props;
            return (jsx_runtime_1.jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fillRule: "evenodd", viewBox: "0 0 32 32", "aria-hidden": "true", className: classes.root, style: { width: size, height: size } }, { children: jsx_runtime_1.jsx("path", { d: "M7.61127 17.4737L14.1266 23.989L15.3468 22.7675L9.43694 16.8576H25.1337V15.1315L9.43694 15.1315L15.3468 9.22163L14.1266 8.00011L7.61127 14.5154C7.21981 14.9081 7 15.4401 7 15.9946C7 16.5491 7.21981 17.081 7.61127 17.4737Z", className: classes.fill }, void 0) }), void 0));
        };
    }
}
UiconArrowSimpleLeft.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    size: prop_types_1.default.number
};
UiconArrowSimpleLeft.defaultProps = {
    size: null
};
exports.default = react_jss_1.default(uicon_arrow_simple_left_style_1.default)(UiconArrowSimpleLeft);
//# sourceMappingURL=uicon.arrow.simple.left.js.map